import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon QuantityCheckMarkIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const QuantityCheckMarkIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 18 18">
      <g>
        <g>
          <path d="M9,1c4.42,0,8,3.58,8,8s-3.58,8-8,8s-8-3.58-8-8S4.58,1,9,1z" />
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M7.76,13.18c-0.27,0-0.53-0.11-0.72-0.3L4.09,9.85C3.71,9.45,3.71,8.82,4.11,8.43c0,0,0,0,0,0 c0.4-0.39,1.03-0.38,1.41,0.02l2.27,2.33l5-4.74c0.4-0.38,1.03-0.37,1.41,0.03c0,0,0,0,0,0c0.38,0.4,0.36,1.03-0.04,1.41 c0,0,0,0,0,0l-5.71,5.42C8.27,13.08,8.02,13.18,7.76,13.18z"
          />
        </g>
      </g>
    </Icon>
  )
}
export default QuantityCheckMarkIcon
